export default __webpack_public_path__ + "static/img-3-4a3a3d4d8a8b011b1dd1be4eeb9876c9.png";